import { render, staticRenderFns } from "./KanbanAlertMessage.vue?vue&type=template&id=26ba40a4&scoped=true&"
import script from "./KanbanAlertMessage.vue?vue&type=script&lang=js&"
export * from "./KanbanAlertMessage.vue?vue&type=script&lang=js&"
import style0 from "./KanbanAlertMessage.vue?vue&type=style&index=0&id=26ba40a4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26ba40a4",
  null
  
)

export default component.exports